import { render, staticRenderFns } from "./BulkAttachmentField.vue?vue&type=template&id=6fe99de4&scoped=true&"
import script from "./BulkAttachmentField.vue?vue&type=script&lang=js&"
export * from "./BulkAttachmentField.vue?vue&type=script&lang=js&"
import style0 from "./BulkAttachmentField.vue?vue&type=style&index=0&id=6fe99de4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe99de4",
  null
  
)

export default component.exports